import { useTranslation } from "react-i18next";

import { Banner } from "../atoms/Banner/Banner";

import styles from "./PrivatePreview.module.scss";

export const PrivatePreview = () => {
  const { t } = useTranslation();
  return (
    <Banner>
      <div className={styles.text}>{t("private_preview.text")}</div>
    </Banner>
  );
};
